import {Grid, Typography} from '@mui/material';
import PropTypes from 'prop-types';

import Button from '../../../../../form/buttons/Button/Button';

const PartialUpdateFooter = ({selectedCount, totalCount}) => {
  const buttonText = selectedCount === totalCount ? 'Actualiser tout' : 'Actualiser partiellement';

  return (
    <Grid container alignItems="center" justifyContent="space-between" p={1.5} gap={1}>
      <Grid item xs="auto">
        <Typography fontSize={13}>
          {selectedCount} table{selectedCount > 1 && 's'} sélectionnée{selectedCount > 1 && 's'} sur {totalCount}
        </Typography>
      </Grid>

      <Grid item xs="auto">
        <Button type="submit" variant="contained" color="success" size="small" disabled={selectedCount === 0} sx={{fontSize: 13}}>
          {buttonText}
        </Button>
      </Grid>
    </Grid>
  );
};

PartialUpdateFooter.propTypes = {
  selectedCount: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired
};

export default PartialUpdateFooter;
